var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeSecure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#FEF9EB",
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 32L30.5862 34.0689C31.004 34.4032 31.611 34.3493 31.9634 33.9466L36 29.3333",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3754 19.3887L22.3776 22.9433C20.932 23.5858 19.9862 25.026 20.0507 26.6066C20.4241 35.7583 22.9318 39.4314 29.9268 44.0217C31.1834 44.8463 32.8179 44.8482 34.0742 44.0231C41.1007 39.4083 43.505 35.6711 43.9307 26.6278C44.0057 25.0366 43.0583 23.5814 41.6026 22.9345L33.6246 19.3887C32.5903 18.929 31.4097 18.929 30.3754 19.3887Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeSecure);
export default __webpack_public_path__ + "static/media/safeSecure.3a4f6c9b6f2a2cb7d60de9891d3b0f36.svg";
export { ForwardRef as ReactComponent };